import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Paper, Grid, Divider } from "@mui/material";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import TimeSlotPicker from "./TimeSlotPicker";
import AppointmentForm from "./AppointmentForm";
import {CircularProgress} from '@mui/material';
import axios from "axios";
import { Dialog, DialogContent, DialogActions } from "@mui/material";

// const API_BASE_URL = "https://appointment-schedular-cjjw.onrender.com";
const API_BASE_URL = "https://appointment-schedular-seven.vercel.app";

const Appointment = () => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [selectedName, setSelectedName] = useState(null);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [selectedMobNo, setSelectedMobNo] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [bookedSlots, setBookedSlots] = useState([]);
    const [step, setStep] = useState(0); 
    const [bookingMode, setBookingMode] = useState(null);


    const handleDateSelect = async () => {
        console.log(selectedDate)
        console.log(typeof(selectedDate))
        if (selectedDate) {
            setLoading(true); // Start loading before API call
            try {
                const response = await axios.get(`${API_BASE_URL}/booked-slots?date=${selectedDate}`);
                console.log(response.data)
                setBookedSlots(response.data);
                // Proceed to TimeSlotPicker
            } catch (error) {
                console.error("Error fetching booked slots:", error);
            } finally {
                setLoading(false); // Stop loading after API call
                setStep(2); 
            }
        }
    };





    const handleDateChange = (newDate) => {
        if (!selectedDate || !dayjs(newDate).isSame(selectedDate, "day")) {
            setSelectedDate(newDate);
        }
    };


    const handleNext = () => {
        setStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setStep((prev) => (prev > 0 ? prev - 1 : prev));
        if (step === 1) {
            setSelectedDate(null); // Reset the date when going back to step 0
            setBookingMode(null); // Reset booking mode
        }
        if (step === 2) {
            setSelectedTime(null); // Reset the time when going back to date selection
        }
    };

    const handleFormChange = (e) => {
        console.log(e.target.value)
        if (e.target.name === 'email') {
            setSelectedEmail(e.target.value);
        } else if (e.target.name === 'name') {
            setSelectedName(e.target.value)
        } else {
            setSelectedMobNo(e.target.value)
        }
    }
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Start loading
        try {
            const appointmentData = { selectedDate, selectedTime, selectedEmail, selectedName, selectedMobNo };
            const response = await axios.post(`${API_BASE_URL}/book-appointment`, appointmentData);
            if (response.data.message === 'Appointment booked successfully' || response.data.success) {
                const updatedResponse = await axios.get(`${API_BASE_URL}/booked-slots?date=${selectedDate}`);
                console.log(response.data)
                setBookedSlots(updatedResponse.data);
                setSnackbarMessage('Appointment booked successfully! Please send this across whatsapp  to 9869405747 to confirm appoinment and payment process');
                setSnackbarOpen(true);
            } else {
                setSnackbarMessage("Failed to book. Slot may already be taken.");
                setSnackbarOpen(true);
            }
        }
        catch (error) {
            setSnackbarMessage("Failed to book the appointment. Please check the details entered.");
            setSnackbarOpen(true);
        }
        finally {
            setLoading(false); // Stop loading
        }
    }

    return (
        <>
            <Dialog
                open={snackbarOpen}
                onClose={() => setSnackbarOpen(false)}
                fullWidth
                maxWidth="sm"
                sx={{
                    "& .MuiPaper-root": {
                        borderRadius: "16px",
                        padding: "20px",
                        backgroundColor: snackbarMessage.includes("successfully") ? "#e8f5e9" : "#ffebee",
                        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                    },
                }}
            >
                <DialogContent
                    sx={{
                        textAlign: "center",
                        fontSize: "1.5rem",
                        color: snackbarMessage.includes("successfully") ? "#4caf50" : "#f44336",
                        fontWeight: "bold",
                    }}
                >
                    {snackbarMessage}
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center" }}>
                    <Button
                        onClick={() => setSnackbarOpen(false)}
                        variant="contained"
                        sx={{
                            backgroundColor: snackbarMessage.includes("successfully") ? "#4caf50" : "#f44336",
                            "&:hover": {
                                backgroundColor: snackbarMessage.includes("successfully") ? "#388e3c" : "#d32f2f",
                            },
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Box
                sx={{
                    backgroundColor: "#f4f7fc",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingX: 2,
                }}
            >
                {/* Back Button */}
                {step > 0 && (
                    <Button
                        variant="outlined"
                        onClick={handleBack}
                        sx={{
                            marginBottom: 2,
                            color: "#1976d2",
                            borderColor: "#1976d2",
                            "&:hover": {
                                backgroundColor: "#e3f2fd",
                            },
                        }}
                    >
                        Back
                    </Button>
                )}

                <Paper
                    elevation={5}
                    sx={{
                        padding: 4,
                        borderRadius: 2,
                        backgroundColor: "white",
                        width: "100%",
                        maxWidth: "600px",
                        textAlign: "center",
                        boxShadow: "0 10px 15px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    {/* Step Indicator */}
                    {step > 1 && ( // Hide summary during the "Select Date" step
                        <>
                            <Typography
                                variant="h6"
                                sx={{
                                    marginBottom: 2,
                                    color: "#1976d2",
                                    textAlign: "left",
                                    fontStyle: "italic",
                                }}
                            >
                                {`Booking: ${bookingMode || "N/A"}`}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    marginBottom: 2,
                                    color: "#555",
                                    textAlign: "left",
                                }}
                            >
                                {selectedDate
                                    ? `Selected Date: ${dayjs(selectedDate).format("MMMM D, YYYY")}`
                                    : "No Date Selected"}
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    marginBottom: 2,
                                    color: "#555",
                                    textAlign: "left",
                                }}
                            >
                                {selectedTime
                                    ? `Selected Time: ${selectedTime}`
                                    : "No Time Selected"}
                            </Typography>
                            <Divider sx={{ marginY: 2 }} />
                        </>
                    )}

                    {/* Main Content */}
                    <Typography
                        variant="h4"
                        sx={{
                            marginBottom: 3,
                            fontWeight: "bold",
                            color: "#1976d2",
                            textTransform: "uppercase",
                            letterSpacing: 1,
                            backgroundImage: "linear-gradient(90deg, #1976d2, #1565c0)",
                            backgroundClip: "text",
                            WebkitBackgroundClip: "text",
                            color: "transparent",
                        }}
                    >
                        Book Your Appointment
                    </Typography>

                    {step === 0 && (
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        setBookingMode("clinic");
                                        handleNext();
                                    }}
                                    sx={{ padding: "10px 20px" }}
                                >
                                    In-Clinic
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        setBookingMode("online");
                                        handleNext();
                                    }}
                                    sx={{ padding: "10px 20px" }}
                                >
                                    Online
                                </Button>
                            </Grid>
                        </Grid>
                    )}

                    {step === 1 && (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <StaticDatePicker
                                value={selectedDate}
                                onChange={handleDateChange}
                                onAccept={handleDateSelect} // Handle date selection explicitly
                                shouldDisableDate={(date) => dayjs(date).day() === 3} // Disable Wednesdays
                                minDate={dayjs()} // Start from today
                                maxDate={dayjs().add(8, "weeks")} // Limit to 8 weeks from today
                                displayStaticWrapperAs="desktop"
                                sx={{
                                    "& .MuiPickerStaticWrapper-root": {
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        borderRadius: "8px",
                                    },
                                    "& .MuiDayPicker-day": {
                                        borderRadius: "8px",
                                    },
                                    "& .Mui-selected": {
                                        backgroundColor: "#1976d2 !important",
                                        color: "#fff",
                                    },
                                }}
                            />
                            <Button
                                variant="contained"
                                onClick={handleDateSelect}
                                sx={{
                                    marginTop: 2,
                                    backgroundColor: "#1976d2",
                                    "&:hover": {
                                        backgroundColor: "#1565c0",
                                    },
                                }}
                                disabled={!selectedDate}
                            >
                                {loading ? (
                                    <CircularProgress size={24} sx={{ color: "white" }} />
                                ) : (
                                    "Continue"
                                )}
                            </Button>
                        </LocalizationProvider>

                    )}

                    {step === 2 && (
                        <TimeSlotPicker
                            selectedDate={selectedDate}
                            setTimeSlot={setSelectedTime}
                            handleBack={handleBack}
                            handleNext={handleNext}
                            bookedSlots={bookedSlots}
                            bookingMode={bookingMode}
                        />
                    )}

                    {step === 3 && (
                        <AppointmentForm
                            formData={{}}
                            loading={loading}
                            handleFormChange={(e) => handleFormChange(e)}
                            handleFormSubmit={handleFormSubmit}
                        />
                    )}
                </Paper>
            </Box>
        </>
    );
};

export default Appointment;
